'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));
var PropTypes = _interopDefault(require('prop-types'));
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var icon_treat = require('./icon.treat.js');

/**
 * Icon
 *
 * @visibleName
 * @see Added: v6.2.0, Last updated: v6.2.0
 */

var IconWrapper = function IconWrapper(_ref) {
  var size = _ref.size,
      type = _ref.type,
      viewbox = _ref.viewbox,
      title = _ref.title,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["size", "type", "viewbox", "title", "className", "children"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 ".concat(viewbox, " ").concat(viewbox),
    className: classnames('svg-icon', "svg-icon-".concat(type), icon_treat.Icon.base, _defineProperty({}, icon_treat.Icon.caret, type === 'caret'), className),
    width: size || "".concat(viewbox, "px"),
    height: size || "".concat(viewbox, "px"),
    "aria-label": title,
    "aria-hidden": !title
  }, props), children);
};

process.env.NODE_ENV !== "production" ? IconWrapper.propTypes = {
  /**
   * Will override the default sizes (default: 18px and lg: 32px). Must include unit ie `24px`.
   *
   * Can be different unit types other than 'px' eg: `em`, `rem`, `%`, `pt`, `vh` etc.
   * @since Version 6.0.0
   */
  size: PropTypes.string,

  /**
   * If title is added aria-hidden="true" is replaced with aria-label="title", to better discribe the element for screen readers.
   * @since Version 6.0.0
   */
  title: PropTypes.string,

  /**
   * Specify your own classname into this prop, if you need to customise layout of this component.
   * This classname will be put into the parent container of this component.
   * @since Version 6.0.0
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  type: PropTypes.string,

  /**
   * @ignore
   */
  viewbox: PropTypes.number.isRequired
} : void 0;
IconWrapper.defaultProps = {
  size: undefined,
  title: undefined,
  type: undefined,
  className: undefined,
  children: undefined
};

exports.default = IconWrapper;
